import React, { Component } from "react";
import "./styles.css";
// import Divider from "../../prefabs/divider/view";
// import Icon from "../../prefabs/icon/view";

class InputText extends Component {

  fnameFocus = 0;
  lnameFocus = 0;

  // ===============================================================================================
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onFocus = this.onFocus.bind(this)
    localStorage.setItem('fnameFocus', 0)
    localStorage.setItem('lnameFocus', 0)
  }

  // ===============================================================================================
  onChange(e) {
    e.preventDefault()
    switch (this.props.type) {
      case "number": {
        // Get input and convert to a number
        let numberOnly = (e.target.value).replace(/[^0-9]/gi, '');  // Only allow numbers
        if (numberOnly !== "") {
          numberOnly = parseInt(numberOnly, 10) // Parse as number
        }
        this.props.handleChange(numberOnly)
        break
      }
      case "text": {
        let textOnly = (e.target.value)
        if (!/[^a-zA-Z- ]/.test(textOnly))
        this.props.handleChange(textOnly)
        break
      }
      case "summary": {
        let summaryOnly = (e.target.value)
        if (!/[^a-zA-Z- ]/.test(summaryOnly))
        this.props.handleChange(summaryOnly)
        break
      }
      case "email": {
        let emailOnly = e.target.value
        this.props.handleChange( emailOnly )
        this.onBlur(e);
        break;
      }
      case "phone": {
        let phoneOnly = (e.target.value)
        // Remove spaces from the input
        const strippedValue = phoneOnly.replace(/\s/g, '');
        
        // Validate against the regex
        const phoneRegex = /^\+?[0-9\/-]{0,15}$/;
        
        if (phoneRegex.test(strippedValue)) {
          this.props.handleChange(strippedValue);
        }
        this.onBlur(e);
        break;
      }

      default:
        this.props.handleChange( e.target.value )
    }
  }

  // ===============================================================================================


  onFocus(e) {
    // console.log('*** focuse', this.fnameFocus, ' : ',  e , ' : ', document.querySelector('.input-first-name'), ' *** ', e.currentTarget.placeholder);

    if (e.currentTarget.placeholder === 'First Name') {
      // console.log('First Name');
      // document.querySelector('.fnameFocus').value(1);
      localStorage.setItem('fnameFocus', 1);
    }

    if (e.currentTarget.placeholder === 'Last Name') {
      // console.log('Last name');
      localStorage.setItem('lnameFocus', 1);
    }

    // const firstNameInput = document.querySelector('.input-first-name input')
    // const firstNameValue = firstNameInput.value
    // const firstNameError = document.querySelector('.input-first-name .invalid-field-text')
    // const lastNameInput = document.querySelector('.input-last-name input')
    // const lastNameValue = lastNameInput.value
    // const lastNameError = document.querySelector('.input-last-name .invalid-field-text')


  }

  onBlur(e) {
    e.preventDefault()

    if (this.props.handleBlur) {
      this.props.handleBlur()
    }

    switch (this.props.type) {
      case "text": {
        const firstNameInput = document.querySelector('.input-first-name input')
        const firstNameValue = firstNameInput.value
        const firstNameError = document.querySelector('.input-first-name .invalid-field-text')
        const lastNameInput = document.querySelector('.input-last-name input')
        const lastNameValue = lastNameInput.value
        const lastNameError = document.querySelector('.input-last-name .invalid-field-text')

        // console.log('--> check vals', `firstName: ${document.formName.elements['fnameFocus'].value} lastName: ${document.formName.elements['lnameFocus'].value}`);

        // if (firstNameValue === '' && lastNameValue !== '') {
        //   firstNameError.style.display = 'block'
        //   lastNameError.style.display = 'none'
        // } else if (firstNameValue !== '' && lastNameValue === '') {
        //   firstNameError.style.display = 'none'
        // } else if (firstNameValue !== '' && lastNameValue !== '') {
        //   firstNameError.style.display = 'none'
        //   lastNameError.style.display = 'none'
        // } else {
        //   console.log('falling here');
        //   // firstNameError.style.display = 'block'
        //   // lastNameError.style.display = 'block'
        // }

        // console.log('localStorage.getItem(fnameFocus)', localStorage.getItem('fnameFocus'));

        if (localStorage.getItem('fnameFocus') === '1' && firstNameInput && (firstNameValue === '' || firstNameValue === undefined)) {
          // console.log('firstname empty');
          firstNameError.style.display = 'block'
          // lastNameError.style.display = 'none'
        } else if (firstNameValue.length > 0) {
          // console.log('firstname ok');
          firstNameError.style.display = 'none'
          localStorage.setItem('fnameFocus', 0)
        }

        if (localStorage.getItem('lnameFocus') === '1' && lastNameInput && (lastNameValue === '' || lastNameValue === undefined)) {
          // console.log('lastname empty');
          lastNameError.style.display = 'block'
        } else if (lastNameValue.length > 0) {
          // console.log('lastname ok');
          lastNameError.style.display = 'none'
          localStorage.setItem('fnameFocus', 0)
        }


        break
      }
      case "email": {
        let invalidEmailField = document.querySelectorAll('.invalid-field.invalid-field-email')

        for (let i = 0; i < invalidEmailField.length; i++) {
        let emailOnlyValue = e.target.value
          if (emailOnlyValue === '') {
            invalidEmailField[i].style.display = 'block'
            // console.log('is blank = yes')
          } else {
            invalidEmailField[i].style.display = 'none'
            // console.log('is blank = nope')
            if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi.test(emailOnlyValue)) {
              invalidEmailField[i].style.display = 'none'
              // console.log('regex = this should hide message')
            } else {
              invalidEmailField[i].style.display = 'block'
              // console.log('regex = this should show message')
            }
          }
        }

        break
      }
      case "phone": {
        let invalidPhoneField = document.querySelectorAll('.invalid-field.invalid-field-phone')
        for (let i = 0; i < invalidPhoneField.length; i++) {
          let phoneOnlyValue = e.target.value
          if (phoneOnlyValue === '') {
            invalidPhoneField[i].style.display = 'block'
          } else {
            invalidPhoneField[i].style.display = 'none'
            const phoneRegex = /^\+?[0-9\/-]{10,15}$/;
            if (phoneRegex.test(phoneOnlyValue)) {
              invalidPhoneField[i].style.display = 'none';
            } else {
              invalidPhoneField[i].style.display = 'block';
            }
          }
        }

        break
      }
      default:
    }
  }

  // ===============================================================================================
  render() {
    return (
      <label
        className={"input-text" + ((this.props.disabled) ? " input-text--disabled" : "") + ((this.props.className) ? " " + this.props.className : "")}
        tabIndex="-1"
      >
        <input
          type="text"
          className={"input-text__input" + ((this.props.type)  ? " input-text__input--" + this.props.type  : "")}
          placeholder={this.props.placeholder}
          value={this.props.value}
          // name={this.props.name}
          id={this.props.inputId}
          maxLength={this.props.maxLength}
          // disabled={this.props.disabled}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          required={true}
        />
        <div className="input-text__icon">
          {/* <Icon type="pen"/> */}
        </div>
        {/* <Divider type="dotted-yellow" className="input-text__underline"/> */}
        <div className={this.props.type  ? `invalid-field invalid-field-${this.props.type}` : ''}>Please enter a valid {this.props.placeholder}</div>
      </label>
    );
  }

}

export default InputText
